import logger from '../logger'
import extendedObservable from './base'
import api from '../api'
import {
  get,
  isFunction,
} from 'lodash-es'
import './line-items'


export function ListsObservable() {
  extendedObservable(this, 'listsModel', [])

  const notifyMe = data => new Promise((resolve, reject) => {
    api.customerLists.notifyMe(data)
      .then(resolve)
      .fail(reject)
  })

  this.on('notifyMe', (data, cb, errCb) => {
    notifyMe(data)
      .then(this.notifyObservers)
      .then(cb)
      .catch((err) => {
        const errorContent = get(err, 'responseJSON.error')
        const orderIssuesContent = get(err, 'responseJSON.orderIssues')

        logger(err, 'debug')()

        if (isFunction(errCb)) errCb(errorContent || orderIssuesContent)
      })
  })
}
